"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyDOMRect = exports.DEFAULT_WIDTH_RESIZER_HEIGHT = exports.DEFAULT_COLUMN_CLIENT_WIDTH = void 0;
exports.DEFAULT_COLUMN_CLIENT_WIDTH = 100;
exports.DEFAULT_WIDTH_RESIZER_HEIGHT = 300;
exports.emptyDOMRect = {
    x: 0,
    y: 0,
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    height: 0,
    width: 0,
};
//# sourceMappingURL=constants.js.map